import React, { Component } from "react";
import { message } from "antd";
import axios from "axios";
import { connect } from "react-redux";
import { ModalItem, ButtonItem } from "../../../../Components/Items";
import { DownloadOutlined } from "@ant-design/icons";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import resumenInsumosPdf from "../../../../Pdf/resumenInsumosPdf";

pdfMake.vfs = pdfFonts.pdfMake.vfs;

class ModalResumenInsumos extends Component {
  state = {
    loading: false,
    pdf: null,
  };

  componentDidUpdate(prevProps) {
    if (this.props.visible !== prevProps.visible && this.props.visible) {
      this.generarPdf();
    }
  }

  async generarPdf() {
    this.setState({ loading: true, pdf: null });

    await axios
      .post(
        "ventas/resumenInsumos",
        { ventaId: this.props.ventaId, empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.success === 2) {
          const dd  = resumenInsumosPdf(res.data);
          const pdf = pdfMake.createPdf(dd);
          this.setState({ loading: false, pdf }, () => {
            pdf.open({}, window.frames["resumenInsumosPdfFrame"]);
          });
        } else {
          message.error("No se pudo generar el resumen de insumos");
          this.setState({ loading: false });
        }
      })
      .catch(() => {
        message.error("Error al obtener los datos");
        this.setState({ loading: false });
      });
  }

  descargarPdf() {
    this.state.pdf?.download("Resumen_Insumos.pdf");
  }

  render() {
    return (
      <ModalItem
        title="Resumen de Insumos"
        visible={this.props.visible}
        spinning={this.state.loading}
        onCancel={this.props.onCancel}
        paddingTop
        width={900}
      >
        <div style={{ display: "flex", justifyContent: "flex-end", gap: 8, marginBottom: 10 }}>
          <ButtonItem
            icon={<DownloadOutlined />}
            blanco
            onClick={this.descargarPdf.bind(this)}
            disabled={!this.state.pdf}
          >
            Descargar PDF
          </ButtonItem>
          <ButtonItem type="primary" danger onClick={this.props.onCancel}>
            Cerrar
          </ButtonItem>
        </div>

        <iframe
          title="resumenInsumos"
          style={{ width: "100%", height: "75vh", border: "none" }}
          id="resumenInsumosPdfFrame"
          name="resumenInsumosPdfFrame"
        />
      </ModalItem>
    );
  }
}

const mapStateToProps = (state) => ({
  headersToken: state.user.headersToken,
  empresaId:    state.empresa.id,
});

export default connect(mapStateToProps)(ModalResumenInsumos);